import type { LocaleObject } from 'yup';
import { setLocale } from 'yup';

type Translation = (key: string) => string;

function getYupLocaleObject(t: Translation): LocaleObject {
    return {
        mixed: {
            default: t('yupFormValidation.mixed.defaultInvalid'),
            required: t('yupFormValidation.mixed.required'),
        },
        string: {
            length: t('yupFormValidation.string.length'),
            min: t('yupFormValidation.string.min'),
            max: t('yupFormValidation.string.max'),
            email: t('yupFormValidation.string.email'),
        },
        number: {
            min: t('yupFormValidation.number.min'),
            max: t('yupFormValidation.number.max'),
            lessThan: t('yupFormValidation.number.lessThan'),
            moreThan: t('yupFormValidation.number.moreThan'),
            positive: t('yupFormValidation.number.positive'),
            negative: t('yupFormValidation.number.negative'),
        },
        date: {
            min: t('yupFormValidation.date.min'),
            max: t('yupFormValidation.date.max'),
        },
    };
}

export function setYupLocale(t: Translation): void {
    setLocale(getYupLocaleObject(t));
}
